import { render, staticRenderFns } from "./SettingIndex.vue?vue&type=template&id=0d57cd76&scoped=true&"
import script from "./SettingIndex.vue?vue&type=script&lang=ts&"
export * from "./SettingIndex.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d57cd76",
  null
  
)

export default component.exports